import { useState } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

import { useModal } from "./useModal";
import { handleError } from "utils/error/handleError";
import { callDeleteMap } from "api/worker/map";
import { CleaningMapList } from "types/response/map";
import { mapKey, robotKey } from "./worker/keys";
import { notify } from "lib/notify";
import { CleaningRobotList } from "types/response/robot";

/**
 * マップ削除
 */
export const useDeleteMapModal = () => {
  const [mapId, setMapId] = useState<string | undefined>(undefined);
  const navigate = useNavigate();
  const modal = useModal();
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const onOpen = (mapId: string) => {
    setMapId(mapId);
    modal.onOpen();
  };

  const onDelete = async () => {
    setIsLoading(true);
    try {
      if (!mapId) {
        throw new Error("マップが選択されていません");
      }

      // 削除リクエスト送信
      await callDeleteMap({
        mapId,
      });

      // キャッシュから対象マップを削除
      queryClient.setQueryData<CleaningMapList | undefined>(
        mapKey.list(),
        (prev) => {
          if (!prev) return undefined;
          return prev.filter((m) => m.mapId !== mapId);
        }
      );

      // キャッシュからスケジュールを削除
      queryClient.setQueryData<CleaningRobotList | undefined>(
        robotKey.list(),
        (prev) => {
          if (!prev) return undefined;
          return prev.map((r) => ({
            ...r,
            schedules: r.schedules.filter((s) => s.mapId !== mapId),
          }));
        }
      );

      notify("削除しました");
      navigate(`/MapSchedule`);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    ...modal,
    onOpen,
    isLoading,
    onDelete,
  };
};
